import './style.scss'
import packageJson from '../../../package.json'
import ImagemLogo from '../../images/Logo_MP_Horizontal_Transp.png'

// Injetado pelo webpack (DefinePlugin) com a data+hora do build (fuso de Brasília).
declare const __APP_BUILD_DATETIME__: string

const Footer = () => {
  const version = packageJson.version

  return (
    <footer className='footer-container'>
      <div className='footer-content'>
        <div className='footer-logo-container'>
          <img src={ImagemLogo} alt='Ministério Público do Estado do Rio de Janeiro' />
        </div>
        <div className='footer-container__content'>
          {process.env.REACT_APP_AMBIENT && (
            <div className='footer-container__content__text'>{process.env.REACT_APP_AMBIENT}</div>
          )}
          <div className='footer-container__content__version'>
            <span>Versão {version ?? '0.0.0'}</span>
            <span>{__APP_BUILD_DATETIME__}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
